import { render, staticRenderFns } from "./NewsItemNA.vue?vue&type=template&id=0c52288f&scoped=true&"
import script from "./NewsItemNA.vue?vue&type=script&lang=ts&"
export * from "./NewsItemNA.vue?vue&type=script&lang=ts&"
import style0 from "./NewsItemNA.vue?vue&type=style&index=0&id=0c52288f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c52288f",
  null
  
)

export default component.exports